import { SWRFetcher } from '@commenda/utils';
import useSWR from 'swr';

import {
  TIndirectTaxTransactionExtendedParams,
  TIndirectTaxTransactionExtendedResponse,
} from './types';

export function useIndirectTaxTransactionExtended({
  transactionId,
  corporationId,
  extendedFields,
  target_currency,
}: TIndirectTaxTransactionExtendedParams) {
  const queryParams = new URLSearchParams();

  if (extendedFields) {
    queryParams.append('extend', extendedFields.join(','));
  }

  queryParams.append('corporationId', corporationId);

  if (target_currency) {
    queryParams.append('target_currency', target_currency);
  }

  const { data, error, isLoading, mutate } =
    useSWR<TIndirectTaxTransactionExtendedResponse>(
      transactionId
        ? `new-sales-tax/transactions/${transactionId}?${queryParams.toString()}`
        : null,
      SWRFetcher({ method: 'GET' }, undefined)
    );

  return {
    data: data?.data,
    error,
    mutate,
    isLoading,
  };
}
